export var SignaturePositions;
(function (SignaturePositions) {
    SignaturePositions["HIDE"] = "hide";
    SignaturePositions["LEFT"] = "left";
    SignaturePositions["CENTER"] = "center";
    SignaturePositions["RIGHT"] = "right";
})(SignaturePositions || (SignaturePositions = {}));
//# sourceMappingURL=emailTemplate.js.map